import { Button, Form } from 'antd';
import { IGameEnvModel } from '../../../../model/api-modules/env';
import { EnvSync } from './env-sync';
import {
  IAPIGameItem,
  IAPIServiceConfigItem,
  IAuditItem,
} from '../../../../model/api-modules';
import { RbacRoleObjectKey } from '../../../../model/rbac';
import { useEffect, useState } from 'react';
import { messageError } from '../../../../components/message';
import { SvgIcon } from '../../../../components/svg-icon';
import { SvgIconName } from '../../../../components/svg-icon/model';
import getFormatMessage from '../../../../locales/get-format-message';
import { PermissionCheck } from '../../../component/permission-check';
import { AutoTable } from '../../../../components/auto-table';
import { auditReadLog } from '../../../lib/aduit-log';
import { EnvExport } from './env-export';
// import { useHistory } from 'react-router-dom';
import exportIcon from '../../../../assets/svg/cloud-download.svg';
import uploadIcon from '../../../../assets/svg/cloud-upload-new.svg';
import { CommonButton } from '../../../../components/button/main';
import { EnvImport } from './env-import';

interface IProps {
  readonly selectedGame?: IAPIGameItem;
  readonly envList: ReadonlyArray<IGameEnvModel>;
  readonly gameID?: string;
  readonly onDeleteRecord: (record: IGameEnvModel) => void;
  readonly columns: any;
  readonly onShowCreateDrawer: () => void;
  readonly loading: boolean;
  readonly allServiceConfig: ReadonlyArray<IAPIServiceConfigItem> | null;
  readonly envID?: string;
}

export const TabEnvs = (props: IProps) => {
  // const history = useHistory();
  const [form] = Form.useForm();
  const [showSync, setShowSync] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [showExport, setShowExport] = useState<boolean>(false);
  const [showImport, setShowImport] = useState<boolean>(false);

  useEffect(() => {
    const pathname = location.pathname.split('/');
    const gameInfoIndex = pathname.indexOf('game-info');
    if (gameInfoIndex !== -1) {
      const gameId = pathname[gameInfoIndex + 1];
      const envId = pathname[gameInfoIndex + 2];
      const envItem = props.envList.find((item) => item.id === Number(envId));
      if (envItem) {
        auditReadLog(IAuditItem.ViewGameEnvironments, {
          gameID: gameId,
          envID: envItem.Guid,
          envType: envItem.Type,
          detail: {
            gameID: gameId,
            envID: envItem.Guid,
          },
        });
      }
    }
  }, []);

  const onAddEnv = () => {
    if (props.envList.length >= 30) {
      messageError(getFormatMessage('up_to_30_env'));
    } else {
      props.onShowCreateDrawer();
    }
  };

  const showSyncDrawer = () => {
    setShowSync(true);
  };

  const onCloseSyncDrawer = () => {
    setShowSync(false);
  };

  const onChangedFilterValues = () => {};

  // const goSyncTask = () => {
  //   history.push(`/studio/${props.selectedGame?.studioID}/audithub`);
  // };

  const clickExport = () => {
    setShowExport(true);
  };
  const onCloseExportDrawer = () => {
    setShowExport(false);
  };

  const clickImport = () => {
    setShowImport(true);
  };
  const onCloseImportDrawer = () => {
    setShowImport(false);
  };

  const sortEnvList = [...props.envList].sort(
    (a: IGameEnvModel, b: IGameEnvModel) => {
      const aTime = a.CreateTime ? new Date(a.CreateTime).getTime() : 0;
      const bTime = b.CreateTime ? new Date(b.CreateTime).getTime() : 0;
      return aTime - bTime;
    }
  );
  return (
    <div>
      <div className="tableEnvBtn">
        <PermissionCheck
          permissionKey={RbacRoleObjectKey.EnvCreate}
          gameID={props.gameID}
        >
          <Button
            className="gc-btn gc-btn-primary"
            icon={
              <SvgIcon
                className="in-game-ant-icon"
                icon={SvgIconName.InviteAddIcon}
              />
            }
            onClick={onAddEnv}
          >
            <span className="btn-text">
              {getFormatMessage('add_environment')}
            </span>
          </Button>
        </PermissionCheck>
        <PermissionCheck
          permissionKey={RbacRoleObjectKey.EnvSync}
          gameID={props.gameID}
        >
          <Button className="gc-btn gc-btn-default" onClick={showSyncDrawer}>
            <span className="btn-text">
              {getFormatMessage('environment_sync')}
            </span>
          </Button>
        </PermissionCheck>
        <div className="right-btn-box">
          <PermissionCheck
            permissionKey={RbacRoleObjectKey.EnvironmentImport}
            gameID={props.gameID}
          >
            <CommonButton type="link" onClick={() => clickImport()}>
              <div className="right-btn-upload">
                <img src={uploadIcon} />
              </div>
            </CommonButton>
          </PermissionCheck>
          <PermissionCheck
            permissionKey={RbacRoleObjectKey.EnvironmentExport}
            gameID={props.gameID}
          >
            <CommonButton type="link" onClick={() => clickExport()}>
              <div className="right-btn-export">
                <img src={exportIcon} />
              </div>
            </CommonButton>
          </PermissionCheck>
        </div>
        {/* <PermissionCheck
          permissionKey={RbacRoleObjectKey.EnvView}
          gameID={props.gameID}
        >
          <Button className="gc-btn gc-btn-default" onClick={goSyncTask}>
            <span className="btn-text">
              {getFormatMessage('view_environment_sync_task')}
            </span>
          </Button>
        </PermissionCheck> */}
      </div>
      <Form form={form} component={false}>
        <AutoTable
          list={sortEnvList}
          configFields={props.columns}
          loading={props.loading}
          tableExtension={{
            onChange: (changeInfo) => {
              if (!changeInfo) {
                return;
              }
              setCurrentPage(changeInfo.current);
              setPageSize(changeInfo.pageSize || 10);
            },
            pagination: {
              current: currentPage,
              total: props.envList.length,
              pageSize,
              showTotal: () => {
                return `Total ${props.envList.length} items`;
              },
            },
            scroll: { x: 'auto' },
          }}
          layoutExtension={{
            showTopbar: false,
            showFilter: true,
          }}
          onChangedFilterValues={onChangedFilterValues}
        />
      </Form>
      <EnvSync
        allServiceConfig={props.allServiceConfig}
        onClose={onCloseSyncDrawer}
        visible={showSync}
        envList={props.envList}
        selectedGame={props.selectedGame}
        selectedEnv={props.envID}
      />
      <EnvExport
        visible={showExport}
        onClose={onCloseExportDrawer}
        envList={props.envList}
        selectedGame={props.selectedGame}
        allServiceConfig={props.allServiceConfig}
      />
      <EnvImport
        visible={showImport}
        onClose={onCloseImportDrawer}
        envList={props.envList}
        selectedGame={props.selectedGame}
        allServiceConfig={props.allServiceConfig}
      />
    </div>
  );
};
